import AOS from "aos"

export default class Animation {
   constructor() {
      this.init()
   }

   init() {
      this.addAosAttributes()
      AOS.init({
         once: true,
         duration: 700,
         easing: "ease-out",
         throttleDelay: 200,
         offset: 100,
      })
   }

   addAosAttributes() {
      let animatedElems = document.querySelectorAll(".fade-right, .fade-left, .fade-columns, .fade-in")

      if (animatedElems) {
         animatedElems.forEach((item, index) => {
            if (item.classList.contains("fade-right")) {
               item.setAttribute("data-aos", "fade-right")
            } else if (item.classList.contains("fade-in")) {
               item.setAttribute("data-aos", "fade-in")
            } else if (item.classList.contains("fade-left")) {
               item.setAttribute("data-aos", "fade-left")
            } else if (item.classList.contains("fade-columns")) {
               let columns = item.querySelectorAll(".wp-block-column")
               if (columns.length) {
                  columns.forEach((col, index) => {
                     col.setAttribute("data-aos", "fade-up")
                     col.setAttribute("data-aos-delay", 150 * index)
                  })
               }
            }

            // if (animatedElems.length == index + 1) {
            //    setTimeout(() => {
            //       AOS.init({
            //          once: true,
            //          duration: 700,
            //          easing: "ease-out",
            //          throttleDelay: 200,
            //          offset: 100,
            //       })
            //    }, 500)
            // }
         })
      }
   }
}



//////////////////
// WEBPACK FOOTER
// ./js/components/animation.js
// module id = 6
// module chunks = 0